import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "templateLink", "fileInput", "modal", "seasonSelect" ]

  connect() {
    // console.log("Hello, Import Roster Controller here!", this.element);

    // Team Settings → Roster season rows pass their season, so the modal opens with that season selected.
    if (this.hasModalTarget && this.hasSeasonSelectTarget) {
      this.modalTarget.addEventListener('show.bs.modal', event => {
        const button = event.relatedTarget;
        const seasonId = button && button.dataset.importSeasonId;

        if (seasonId) {
          this.seasonSelectTarget.value = seasonId;
        }
      });
    }
  }

  updateFileType(event) {
    this.fileInputTarget.value = '';
    this.fileInputTarget.files = new DataTransfer().files;
    this.fileInputTarget.dispatchEvent(new Event('change', { bubbles: true }));

    if (event.target.value === 'csv') {
      this.templateLinkTarget.classList.remove('d-none');
      this.templateLinkTarget.classList.add('d-block');

      this.fileInputTarget.accept = '.csv';
    } else {
      this.templateLinkTarget.classList.remove('d-block');
      this.templateLinkTarget.classList.add('d-none');

      this.fileInputTarget.accept = '.pdf';
    }
  }
}
